import React from "react";
import pic from "../img/picture.png";

const Intro: React.FC = () => (
  <header className="masthead bg-primary What text-white text-center" id="what">
    <div className="container">
      <img
        className="img-fluid mb-5 d-block mx-auto"
        style={{
          width: "150px",
          height: "150px",
          borderRadius: "50%",
        }}
        src={pic}
        alt="Hillary Kimaita"
      />
      <h1 className="text-uppercase mb-0">What I do</h1>
      <hr className="star-light" />
      <h2 className="font-weight-light mb-0">
        Full Stack Developer( React, React-Native, NodeJs ) - Web Developer -
        Mobile App Developer
      </h2>
    </div>
  </header>
);

export default Intro;
